<template>
    <modal size="lg" :height-max="true" @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Add Accrual Plan</h3>
        </template>

        <slot>
            <form class="mui-form" @submit.prevent="onSubmit()">
                <div class="form-row">
                    <div class="col">
                        <form-input
                            v-model="formData.accrual_plan_id"
                            :errors="errors.accrual_plan_id"
                            type="select"
                            label="Plan"
                            :options="planOptions"
                            helper-text="Plans the client already has aren't listed. Use Create Custom Plan for one of the client's own."
                        />
                    </div>
                </div>

                <positions-fields v-model:all-positions="formData.all_positions" v-model:positions="formData.positions" :client="client" :errors="errors" />
            </form>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">Add</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PositionsFields from './PositionsFields'

export default {
    props: ['client', 'clientPlans', 'globalPlans', ],
    mixins: [FormMixin, ModalMixin],
    emits: ['close', 'updated', ],
    components: {PositionsFields, },
    computed: {
        planOptions() {
            const taken = new Set(this.clientPlans.filter(cp => cp.is_active).map(cp => cp.accrual_plan_id))
            return this.globalPlans
                .filter(p => !taken.has(p.id))
                .map(p => ({text: `${p.name} (${p.state_pretty || 'All States'})`, value: p.id}))
                .sort((a, b) => a.text.localeCompare(b.text))
        },
    },
    data() {
        return {
            formData: {
                accrual_plan_id: '',
                all_positions: false,
                positions: [],
            },
        }
    },
    methods: {
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.post(`/clients/${this.client.id}/settings/accrual-plans`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    },
}
</script>
